import React from "react";
import CustomSelect from "@/components/Select/Select";
import { Button, Modal, SelectChangeEvent, TextField } from "@mui/material";
import styles from "./AddAdminModal.module.scss";
import { AdminRole } from "@/store/models/admin.models";
import { useForm } from "react-hook-form";

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleRoleChange: (event: SelectChangeEvent<AdminRole>) => void;
  onSubmit: (data: { emails: string }) => Promise<void>;
  selectedStatus: AdminRole;
};

const options = Object.values(AdminRole).map((role) => ({
  value: role,
  label: role.charAt(0).toUpperCase() + role.slice(1),
}));

export const AddAdminModal = ({
  open,
  setOpen,
  handleRoleChange,
  onSubmit,
  selectedStatus,
}: Props) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<{ emails: string }>();

  return (
    <Modal
      aria-labelledby="modal-adding-admin"
      aria-describedby="Adding an administrator to the system. Enter the required information and click Save to continue."
      open={open}
      onClose={() => setOpen(false)}
    >
      <div className={styles.modalContainer}>
        <h3 className={styles.modalTitle}>Add admin</h3>
        <form className={styles.modalContent} onSubmit={handleSubmit(onSubmit)}>
          <TextField
            autoComplete="false"
            className={styles.input}
            variant="outlined"
            label="Email"
            placeholder="Your email adress"
            {...control.register("emails", {
              required: "Email is required",
            })}
            error={!!errors.emails}
            helperText={errors.emails ? String(errors.emails.message) : ""}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#eff1f999",
              },
            }}
          />

          <CustomSelect
            label="Status"
            options={options}
            value={selectedStatus}
            onChange={handleRoleChange}
          />
          <div className={styles.btns}>
            <Button
              sx={{
                textTransform: "capitalize",
                height: "44px",
                width: "130px",
                backgroundColor: "#008000",
                border: "none",
                borderRadius: "12px",
                "&:hover": {
                  backgroundColor: "#008000",
                },
              }}
              variant="contained"
              type="submit"
            >
              Save
            </Button>

            <Button
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                height: "44px",
                width: "130px",
                border: "1px solid #5570F1",
                color: "#5570F1",
                borderRadius: "12px",
              }}
              onClick={() => setOpen(false)}
            >
              Close
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

